module.exports = __webpack_public_path__ + "images/6d3afd7e597cce4c79018f687dc2b51a.png";